import React, { useContext } from 'react';
import { globalStore } from '../state/store';
import theme from '../theme/theme';
import { useNavigate } from "react-router-dom";
import { BottomNavigation, BottomNavigationAction, Box, Paper } from '@mui/material';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const BottomNav = (props) => {

    const [state, dispatch] = useContext(globalStore);
    const navigate = useNavigate();

    return (
    
    <Box sx={{ display: { xs: 'block', md: 'none'}, pb: 7 }}>
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, boxShadow: 'rgba(0, 0, 0, 0.10) 0px 3px 24px 0px', zIndex: '1000' }}>

        <BottomNavigation showLabels value={props.page}>
        {state.menuItems.map((item) => (

            <BottomNavigationAction 
            onClick={e => navigate(item.route)}
            key={item.title}
            label={item.title} 
            value={item.title}
            icon={<FontAwesomeIcon icon={item.icon} />} 
            />

        ))}
        </BottomNavigation>

      </Paper>
    </Box>

    );
};
export default BottomNav;